import React from "react";
import "./PrivacyPolicy.scss";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";

const policyData = {
  effectiveDate: "March 11, 2026",
  sections: [
    {
      title: "Information Collection And Use",
      content: [
        "We collect different types of information to provide and improve our services.",
        "Personal Data may include email, name, phone, address, and usage data."
      ]
    },
    {
      title: "Types of Data Collected",
      content: [
        "Personal Data: Email, name, phone, address, cookies, and usage data.",
        "Usage Data: IP address, browser type, pages visited, time spent, and device info."
      ]
    },
    {
      title: "Cookies & Tracking",
      content: [
        "We use cookies and similar technologies to enhance your experience.",
        "You can refuse cookies, but some features may not work."
      ]
    },
    {
      title: "Use of Data",
      content: [
        "To provide and maintain the service.",
        "To notify you about changes.",
        "To improve and analyze our service.",
        "To ensure security and compliance."
      ]
    },
    {
      title: "Transfer & Disclosure",
      content: [
        "Your data may be transferred and processed in India.",
        "We ensure your data is secure and only disclosed when legally required."
      ]
    },
    {
      title: "Security",
      content: [
        "We use industry-standard measures to protect your data, but no method is 100% secure."
      ]
    },
    {
      title: "Service Providers",
      content: [
        "Third-party providers may access your data only to perform tasks on our behalf."
      ]
    },
    {
      title: "Links To Other Sites",
      content: [
        "Our site may link to external sites. Please review their privacy policies."
      ]
    },
    {
      title: "Children's Privacy",
      content: [
        "We do not knowingly collect data from children under 18."
      ]
    },
    {
      title: "Changes To This Policy",
      content: [
        "We may update this policy. Please check this page for changes."
      ]
    },
    {
      title: "Contact Us",
      content: [
        "If you have questions, contact us at info@celbionhealthcare.com."
      ]
    }
  ]
};

export default function PrivacyPolicy() {
  return (
    <>
      <BannerSectionStyle3
        bgUrl="/images/about/banner_bg.jpg"
        imgUrl="/images/about/banner_img.png"
        title="Privacy Policy"
        subTitle="Life beyond limits"
      />
      <div className="privacy-policy-page">
        <div className="privacy-policy-header">
          <p>Effective date: {policyData.effectiveDate}</p>
        </div>
        <div className="privacy-policy-content">
          {policyData.sections.map((section, idx) => (
            <div className="policy-section" key={idx}>
              <h2>{section.title}</h2>
              {section.content.map((item, i) => (
                <p key={i}>{item}</p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
